import { createAsyncThunk } from "@reduxjs/toolkit";
import ReportsAPI, {
    FICReportResponse,
    UpsertFICReportRequest,
} from "../../../api/Reports";
import { MessageResponse } from "../../../api/common";


export const fetchFICReportThunk = createAsyncThunk<
    FICReportResponse,
    { case_id: string },
    { rejectValue: string }
>(
    'reports/fetchFIC',
    async ({ case_id }, { rejectWithValue }) => {
        try {
            return await ReportsAPI.get_fic({ case_id });
        } catch (error: any) {
            return rejectWithValue(error.message || 'Failed to fetch FIC report');
        }
    }
);

export const updateFICReportThunk = createAsyncThunk<
    MessageResponse,
    { case_id: string; request: UpsertFICReportRequest },
    { rejectValue: string }
>(
    'reports/updateFIC',
    async ({ case_id, request }, { rejectWithValue }) => {
        try {
            return await ReportsAPI.update_fic(case_id, request);
        } catch (error: any) {
            return rejectWithValue(error.message || 'Failed to update FIC report');
        }
    }
);

